"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseListExtension = void 0;
const index_js_1 = require("../../../../../entity/actions/update/symbols/index.js");
const reference_js_1 = require("../../../../../entity/actions/update/updateItemParams/extension/reference.js");
const index_js_2 = require("../../../../../schema/actions/parse/index.js");
const isArray_js_1 = require("../../../../../utils/validation/isArray.js");
const isObject_js_1 = require("../../../../../utils/validation/isObject.js");
const parseListExtension = (attribute, input, options) => {
    const { transform = true } = options;
    if ((0, isObject_js_1.isObject)(input)) {
        if ((0, index_js_1.isAppending)(input) && input[index_js_1.$APPEND] !== undefined) {
            const appendedValue = input[index_js_1.$APPEND];
            if ((0, isArray_js_1.isArray)(appendedValue)) {
                return {
                    isExtension: true,
                    *extensionParser() {
                        const parsers = appendedValue.map(element => 
                        // Should a simple list of valid elements (not extended)
                        new index_js_2.Parser(attribute.elements).start(element, { fill: false, transform }));
                        const parsedValue = { [index_js_1.$APPEND]: parsers.map(parser => parser.next().value) };
                        if (transform) {
                            yield parsedValue;
                        }
                        else {
                            return parsedValue;
                        }
                        const transformedValue = { [index_js_1.$APPEND]: parsers.map(parser => parser.next().value) };
                        return transformedValue;
                    }
                };
            }
            return {
                isExtension: true,
                *extensionParser() {
                    const parser = new index_js_2.Parser(attribute).start(appendedValue, {
                        fill: false,
                        transform,
                        parseExtension: reference_js_1.parseReferenceExtension
                    });
                    const parsedValue = { [index_js_1.$APPEND]: parser.next().value };
                    if (transform) {
                        yield parsedValue;
                    }
                    else {
                        return parsedValue;
                    }
                    const transformedValue = { [index_js_1.$APPEND]: parser.next().value };
                    return transformedValue;
                }
            };
        }
        if ((0, index_js_1.isPrepending)(input) && input[index_js_1.$PREPEND] !== undefined) {
            const prependedValue = input[index_js_1.$PREPEND];
            if ((0, isArray_js_1.isArray)(prependedValue)) {
                return {
                    isExtension: true,
                    *extensionParser() {
                        const parsers = prependedValue.map(element => new index_js_2.Parser(attribute.elements).start(element, { fill: false, transform }));
                        const parsedValue = { [index_js_1.$PREPEND]: parsers.map(parser => parser.next().value) };
                        if (transform) {
                            yield parsedValue;
                        }
                        else {
                            return parsedValue;
                        }
                        const transformedValue = { [index_js_1.$PREPEND]: parsers.map(parser => parser.next().value) };
                        return transformedValue;
                    }
                };
            }
            return {
                isExtension: true,
                *extensionParser() {
                    const parser = new index_js_2.Parser(attribute).start(prependedValue, {
                        fill: false,
                        transform,
                        parseExtension: reference_js_1.parseReferenceExtension
                    });
                    const parsedValue = { [index_js_1.$PREPEND]: parser.next().value };
                    if (transform) {
                        yield parsedValue;
                    }
                    else {
                        return parsedValue;
                    }
                    const transformedValue = { [index_js_1.$PREPEND]: parser.next().value };
                    return transformedValue;
                }
            };
        }
    }
    if ((0, isArray_js_1.isArray)(input)) {
        return {
            isExtension: true,
            *extensionParser() {
                const parser = new index_js_2.Parser(attribute).start(input, { fill: false, transform });
                const parsedValue = { [index_js_1.$SET]: parser.next().value };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_1.$SET]: parser.next().value };
                return transformedValue;
            }
        };
    }
    return {
        isExtension: false,
        basicInput: input
    };
};
exports.parseListExtension = parseListExtension;
